import type { Page } from 'components/framework/models';
import type { RecordUnion } from 'components/framework/models/generated/types';
import RecordAction from '../RecordAction';
import type ApplicationModel from 'components/framework/ApplicationModel';

type RecordType = RecordUnion | Page;

export class BulkEditAction extends RecordAction<RecordType> {
  recordTypes = ['Epic', 'Feature', 'Requirement', 'Page'];
  isRemoteLink = true;

  get title() {
    return 'Bulk edit';
  }

  get icon() {
    return 'aha-icon aha-icon-bulk-edit';
  }

  remoteLinkAttributes(records: RecordType[]) {
    const type = records[0].typename.toLowerCase();
    const itemIds = records.map(r => r.id).join(',');
    return {
      href: `/bulk_edits/new?type=${type}&bulk_edit[configuration_item_ids]=${itemIds}&bulk_edit[configuration_all_items]=false`,
    };
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    return (
      super.showForRecord(record) &&
      this.selectedRecords.length > 1 &&
      this.selectedRecords.every(
        r => r.typename === this.selectedRecords[0].typename
      )
    );
  }
}
